/**
 * @file DealStagePill.tsx
 * @description Пилюля стадии сделки (phase19.31, зона «Клиенты и сделки»;
 * SC26–SC28): одна форма в реестре, на доске и в шапке карточки.
 *
 * Фон и текст — тон по ВИДУ стадии (`dealStageView`), цвет, который задал
 * магазин, — только точкой: точку рисует тема (`::before` у пилюли), здесь
 * лишь подменяем её цвет переменной `--badge-dot`. Так «Согласование»
 * бежевого цвета остаётся читаемым, а метка магазина — узнаваемой.
 */

import type { CSSProperties } from "react";

import { Badge } from "../ui/badge";
import { STAGE_KIND_LABEL, type DealDto } from "../../lib/api-crm";
import { dealStageView } from "../../lib/crm-deal-view";
import { STATUS_TONE_VARIANT } from "../../lib/shop/status-meta";
import { cn } from "@/lib/utils";

interface Props {
  deal: Pick<DealDto, "currentStageName" | "currentStageKind" | "currentStageColor">;
  className?: string;
}

export function DealStagePill({ deal, className }: Props) {
  const view = dealStageView(deal);
  const style = view.dot ? ({ "--badge-dot": view.dot } as CSSProperties) : undefined;
  return (
    <Badge
      variant={STATUS_TONE_VARIANT[view.tone]}
      data-status-tone={view.tone}
      style={style}
      // Вид стадии словами — в подсказке: «Сделка успешна · Успешная».
      title={`${view.label} · ${STAGE_KIND_LABEL[deal.currentStageKind]}`}
      className={cn("max-w-full min-w-0", className)}
    >
      <span className="truncate">{view.label}</span>
    </Badge>
  );
}
